import { Component, HostBinding } from '@angular/core';
import { OrderNotificationComponent } from '../order-notification/order-notification.component';
import { ToastrService, ToastPackage } from 'ngx-toastr';
import { ShareService } from '../../services/share.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { WorkspaceServiceService } from '../../services/workspace-service.service';

@Component({
  selector: '[mobile-order-notification]',
  template: require('./mobile-order-notification.component.html'),
  styles: [require('./mobile-order-notification.component.css')],
  animations: [
    trigger('flyInOut', [
        state('inactive', style({
            
            opacity: 0
        })),
        state('active', style({ opacity: 100 })),
        state('removed', style({ opacity: 0 })),
        transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
        transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
      ])],
  preserveWhitespaces: false,
})
export class MobileOrderNotificationComponent extends OrderNotificationComponent {
  footerHeight: string | undefined;
  get modalTitle()
  {
    let title = '';
    if(this.Type!='CancelRs' && !this.hideAllItems)
      title = 'Order Notification';

    else if(this.Type!='CancelRs' && this.hideAllItems)
      title = 'Order Edit';

    else if(this.Type=='CancelRs')
      title = 'Cancel Notification';

    return title;
  }

  get horizontal()
  {
    return this.workspaceService.data.horizontalMode;
  }

  constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage, public shareService: ShareService, public workspaceService: WorkspaceServiceService) 
  {
    super(toastrService, toastPackage, shareService);
  }

}
